import { IStore } from "../../../classes/interfaces";
import { formatBRL } from "../../../helpers/currency.helper";

export function isVariableDeliveryFee(company: IStore): boolean {
  return company.districts.length > 0 || company.distances.length > 0;
}

export function deliveryFeeLabel(company: IStore): string {
  if (isVariableDeliveryFee(company)) return "Variável";
  if ((company.tax || 0) === 0) return "Grátis";
  return formatBRL(company.tax);
}
